import './App.css';
import Chatbot from './Compoenets/ChatBotPopup/ChatBotPopup';
import Home from './Compoenets/Home/Home';
console.log = () => {}
console.error = () => {} 
function App() {
  return (
    <div>
     <Home />
     <Chatbot />
    </div>
  );
}

export default App;
